import React from 'react'
import '../css/durante.scss'

import restaurante1 from '../assets/images/durante/restaurante1.png'
import restaurante2 from '../assets/images/durante/restaurante2.png'
import restaurante3 from '../assets/images/durante/restaurante3.jpg'

import cabina1 from '../assets/images/durante/cabina-Interior.png'
import cabina2 from '../assets/images/durante/cabina-vip.jpg'
import cabina3 from '../assets/images/durante/cabina-accessible.png'


import cubierta1 from '../assets/images/durante/cubierta1.png'
import cubierta2 from '../assets/images/durante/cubierta2.png'
import whatsapp  from '../assets/images/icons/whatsapp.png'


import bebidas1 from '../assets/images/durante/bebidas1.webp'
import bebidas3 from '../assets/images/durante/bebidas3.webp'

//California
import asientoTurista from '../assets/images/durante/cali-asientos-turista.jpg'
import asientoEjecutivo from '../assets/images/durante/cali-asientos-ejecutivos.png'

import cabinaCali from '../assets/images/durante/cali-cabina.jpg'
import cabinaCaliPet from '../assets/images/durante/cali-cabina.jpg'

//Cabo star
import asientoCabo from '../assets/images/durante/asientos-turistas.png'
import asientoVip from '../assets/images/durante/sala-asientos-VIP.png'

import cabinaEstandar from '../assets/images/durante/cabina-Interior.png'
import cabinaVIp from '../assets/images/durante/cabina-vip.jpg'
import capsula from '../assets/images/durante/sleeping-pods.jpg'


import barExt from '../assets/images/durante/bar-ext.png'


const shipImages = {

  "cabo-star":{
    asiento: asientoCabo,
    asientoVip: asientoVip,
    capsula: capsula,
    cabinaEstandar: cabinaEstandar,
    cabinaCaliPet: cabinaVIp,

    asientoVipTitulo: "Asiento VIP",
    asientoVipDescripcion: "Salón de clase ejecutiva con asientos más amplios. Incluye coffee break durante la travesía.",
    cabinaVipTitulo: "Cabina VIP",
    cabinaVipDescripcion: "Cuenta con 2 camas matrimoniales, sala de estar y baño completo. Incluye cesta de cortesía con snacks y bebidas premium."

  },
  "california-star":{
    asiento: asientoTurista,
    asientoVip: asientoEjecutivo,
    capsula: capsula,
    cabinaEstandar: cabinaCali,
    cabinaCaliPet: cabinaCaliPet,

    asientoVipTitulo: "Asiento Ejecutivo",
    asientoVipDescripcion: "Salón ejecutivo con asientos más amplios.",
    cabinaVipTitulo: "Cabina Pet Friendly",
    cabinaVipDescripcion: "Cuenta con 2 literas, TV y baño completo. Se admiten mascotas pequeñas."
  }
}


export default function Durante({ ship = "cabo-star" }) {

  const images = shipImages[ship] || shipImages["cabo-star"];


  return (
    <>
    <section className='durante'>

      {/* RESTAURANTE */}
      <div className='container'>
        <div className='durante-section'>
          
          <div className='durante-info'>
            <span className='durante-tag'>Servicios a bordo</span>

            <h2>Restaurante</h2>

            <p>
              La venta de alimentos y snacks en restaurante y en el bar se encuentra 
              abierta en horarios estipulados dentro del buque. El pago a bordo puede 
              ser en efectivo y tarjeta.
            </p>
            <div>
              <a href='https://www.bajaferries.com.mx/menuqr/' target='_blank' rel="noreferrer" className='durante-link'>
                Ver menú <i class="fi fi-rr-arrow-up-right-from-square"></i>
              </a>

            </div>

            <div className='durante-cards-mini'>
              <div className='durante-mini-card'>
                <i class="fi fi-rs-child-head"></i>
                <h4>¿Vienes con niños?</h4>
                <p>
                  Opciones pensadas para los más pequeños disponibles a bordo.
                </p>
              </div>

              <div className='durante-mini-card'>
                <i class="fi fi-rs-salad"></i>
                <h4>¿Eres vegano?</h4>
                <p>
                  Hemos incorporado nuevas opciones para ti. Solicita información a bordo.
                </p>
              </div>
            </div>
          </div>

          <div className='durante-gallery'>
            <div className='durante-gallery-left'>
              <img src={restaurante3} alt='' />
            </div>

            <div className='durante-gallery-right'>
              <img src={restaurante2} alt='' />
              <img src={restaurante1} alt='' />
            </div>
          </div>
        </div>
      </div>

     {/* BAR */}
      <div className='durante-bar'>
          <div className='container'>

              <div className='durante-bar-content'>

                  <div className='durante-bar-gallery'>

                      <div className='durante-bar-main'>
                          <img src={barExt} alt='' />
                      </div>

                      <div className='durante-bar-side'>
                          <img src={bebidas1} alt='' />
                          <img src={bebidas3} alt='' />
                      </div>
                  </div>

                  <div className='durante-bar-info'>
                      <h2>Bar</h2>

                      <p>
                          Disfruta deliciosas bebidas refrescantes en nuestro bar 
                          interior y exterior con la mejor vista del Mar de Cortés. 
                          Un espacio diseñado para relajarte mientras navegamos.
                      </p>
                      <div>
                        <a href='https://www.bajaferries.com.mx/menuqr/' target='_blank' rel="noreferrer" className='durante-link'>
                          Ver menú de bebidas <i class="fi fi-rr-arrow-up-right-from-square"></i>
                        </a>

                      </div>

                      <div className='durante-bar-payment'>
                          <span>✓</span>
                          <p>
                              Aceptamos tarjetas de crédito y efectivo
                          </p>
                      </div>
                  </div>

              </div>

          </div>
      </div>

      {/* CABINAS */}
      <div className='durante-cabinas'>
        <div className='container'>

          <div className='durante-title-center'>
            <h2>Cabinas</h2>
            <p>
              Nuestros buques cuentan con cabinas que ofrecen un espacio 
              de descanso durante la travesía.
            </p>
          </div>

          <div className='durante-grid'>

            {/* ESTÁNDAR */}
            <div className='durante-card'>
              <div className='durante-card-image'>
                
                <img src={images.cabinaEstandar} alt='' />

              </div>

              <div className='durante-card-content'>
                <h3>Cabina Estándar</h3>

                <span>De 1 hasta 4 pasajeros</span>

                <ul>
                  <li>Cuatro camas individuales</li>
                  <li>TV con contenido precargado</li>
                  <li>Kit de baño (Jabón y shampoo)</li>
                </ul>
              </div>
            </div>

            {/* VIP */}
            <div className='durante-card durante-card-vip'>
              <div className='durante-badge'>
                MÁS CONFORT
              </div>

              <div className='durante-card-image'>
                <img src={images.cabinaCaliPet} alt='' />
              </div>

              <div className='durante-card-content'>
                <h3>{images.cabinaVipTitulo}</h3>
                

                <p>
                  {images.cabinaVipDescripcion}
                </p>

                {/*<div className='durante-divider'></div>

                <h4>Incluye cesta de cortesía:</h4>

                <ul>
                  <li>Snacks y bebidas premium</li>
                  <li>Kit dental y de vanidad</li>
                </ul>*/}
              </div>
            </div>

            {/* ACCESIBLE */}
            <div className='durante-card'>
              <div className='durante-card-image'>
                <img src={cabina3} alt='' />
              </div>

              <div className='durante-card-content'>
                <h3>Cabina Accesible</h3>
                <span>Disponible en buque "Cabo Star"</span>


                <span>Para personas con movilidad reducida</span>

                <ul>
                  <li>Espacios amplios y adaptados</li>
                  <li>2 botellas de agua incluidas</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* ÁREAS DE DESCANSO */}
      <div className='container durante-descanso'>

        <div className='durante-title-center'>
          <h2>Áreas de Descanso</h2>
        </div>

        <div className='durante-grid'>

          {/* ESTÁNDAR */}
          <div className='durante-rest-card'>
            <img src={images.asiento} alt='' />

            <div>
              <h3>Asiento estándar</h3>

              <p>
                Incluido en tu boleto. Área de salón con aire acondicionado, 
                TV y asientos comodos.
              </p>
            </div>
          </div>

          {/* VIP */}
          <div className='durante-rest-card'>
            <img src={images.asientoVip} alt='' />

            <div>
              <h3>{images.asientoVipTitulo}</h3>


              <p>
                {images.asientoVipDescripcion}
              </p>
            </div>
          </div>

          {/* CÁPSULAS */}
          <div className='durante-rest-card'>
            <img src={capsula} alt='' />

            <div>
              <h3>Cápsula de descanso</h3>

              <span>Disponible en buque "Cabo Star"</span>

              <p>
                Módulos individuales privados diseñados para un descanso 
                óptimo en travesías largas.
              </p>
            </div>
          </div>

        </div>
      </div>

            {/* WIFI */}
      <div className='durante-wifi'>
        <div className='container'>

          <div className='durante-title-center'>
            <h2>Planes de WiFi a bordo</h2>

            <p>
              Mantente conectado durante toda tu travesía con nuestras opciones de internet.
            </p>
          </div>

          {/* FEATURES */}
          <div className='wifi-features'>

            <div className='wifi-feature-card'>
              <div className='wifi-icon'>
                <span className="material-symbols-outlined">
                  <i class="fi fi-rs-comment-alt-dots"></i>
                </span>
              </div>

              <h3>WiFi Abordo</h3>

              <p>
                Para que sigas conectado con tu mensajería.
              </p>
            </div>

            <div className='wifi-feature-card'>
              <div className='wifi-icon'>
                <span className="material-symbols-outlined">
                  <i class="fi fi-rs-share"></i>
                </span>
              </div>

              <h3>Redes Sociales</h3>

              <p>
                Comparte tus momentos en línea (con costo).
              </p>
            </div>

            <div className='wifi-feature-card'>
              <div className='wifi-icon'>
                <span className="material-symbols-outlined">
                  <i class="fi fi-rs-play-alt"></i>
                </span>
              </div>

              <h3>Streaming</h3>

              <p>
                Disfruta tus series, música y películas favoritas.
              </p>
            </div>

          </div>

          {/* TABLA */}
          <div className='wifi-table-wrapper'>

            <table className='wifi-table'>

              <thead>
                <tr>
                  <th>PLAN</th>
                  <th>DATOS</th>
                  <th>PRECIO</th>
                </tr>
              </thead>

              <tbody>

                <tr>
                  <td rowSpan="1" className='package'>
                    BF Conecta
                  </td>

                  <td>1 GB</td>
                  <td>$70.00</td>
                </tr>

                <tr>
                  <td rowSpan="1" className='package'>
                    BF Navega
                  </td>

                  <td>2 GB</td>
                  <td>$130.00</td>
                </tr>

            
                <tr>
                  <td rowSpan="2" className='package'>
                    BF Premium
                  </td>

                  <td>3 GB</td>
                  <td>$200.00</td>
                </tr>
                
                

                

              </tbody>

            </table>

          </div>

          <p className='wifi-note'>
            * Los precios están expresados en pesos mexicanos.
          </p>

        </div>
      </div>


      {/* FEEDBACK */}
      <div className='durante-feedback'>
        <div className='container'>
          
          <div className='durante-feedback-content'>

            <div className='durante-feedback-info'>
              <h2>¿Necesitas ayuda con tu viaje?</h2>

              <p>
                Nuestro equipo de soporte está disponible para resolver 
                cualquier duda sobre los servicios a bordo.
              </p>

              <div className='durante-feedback-buttons'>
         
                <div><a href="https://www.bajaferries.com.mx/preguntas-frecuentes" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp"> Preguntas frecuentes</a></div>                                 

                <div><a href="https://wa.me/8003377437?text=Necesito%20ayuda" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp"> <img src={whatsapp} alt='whatsapp baja ferries' /> Contactar por WhatsApp</a></div>                                 
                
              </div>
            </div>

            
            <div className='durante-feedback-card'>
              <h3><i class="fi fi-rs-document-signed"></i> <span>Facturación a bordo</span></h3>
              <p>Si consumes a bordo y requieres factura, solicita tu factura antes de desembarcar.</p>

              <div className='durante-feedback-actions'>

             

              </div>
            </div>
            

          </div>

        </div>
      </div>
    </section>
        
    
    </>
  )
}
